<template>
  <LayoutPage class="news-page frettir-page">
    <PostsFilter
        v-if="!!posts"
        :filters="filters"
        :posts="posts"
        @getLimitPosts="init()"
        @getSubFilter="subFilter"
    />
  </LayoutPage>
</template>

<script>
import {categories} from '@/staticData/blog'
import LayoutPage from '@/layout/blog'
import PostsFilter from '@/components/Blog/AllPosts/PostsFilter/_index'
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'

export default {
  components: {
    LayoutPage,
    PostsFilter
  },
  methods: {
    ...mapActions('blog', {
      // setDataPage: 'SET_DATA_BLOG_PAGE',
      getDataPage: 'GET_DATA_BLOG_PAGE',
    }),
    ...mapMutations({
      setData: 'SET_DATA'
    }),
    subFilter(val) {
      this.subFilterVal = val;
      this.init();
    },
    init() {
      if (this.loading) return
      const hasPosts = !!this.dataPage.posts.length
      this.getDataPage({
        categoryId: categories[0].id,
        limit: hasPosts ? this.dataPage.posts.length + this.limit : this.limit,
        subCategory: this.subFilterVal ? this.subFilterVal.id : 0
      })
    }
  },
  data: () => ({
    subFilterVal: {}
  }),
  computed: {
    ...mapState('blog', {
      limit: state => state.limit,
      loading: state => state.loading
    }),
    ...mapGetters('blog', {
      dataPage: 'GET_DATA_BLOG_PAGE'
    }),
    ...mapState({
      lib: state => state.lib,
    }),
    filters() {
      if (this.lib && this.lib.blog_cat) {
        return this.lib.blog_cat.filter(c => (c.cat == 1)).map(c => ({
          id: c.id,
          title: c.name
        }));
      }
      return this.dataPage && this.dataPage.filters
    },
    posts() {
      return this.dataPage && this.dataPage.posts
          ? this.dataPage.posts.filter((post) => post.category_id === 1)
          : null
    }
  },
  created() {
    this.init()
  },
  beforeDestroy() {
    this.setData({
      field: 'blog.blogPage.posts',
      data: []
    })
  }
}
</script>
